// src/utils/clsx.ts
function clsx(...args) {
  return args.filter(Boolean).join(" ");
}

export { clsx };
